<template>
  <div class="position-relative" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="auto" lg="9" xl="auto" class="position-static">
          <nav class="main-nav d-none d-md-inline-block">
            <ul class="main-nav-list list-unstyled">
              <li v-for="(item, index) in links" :key="`link-${index}`" class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a
                    v-if="!item.isLocalLink"
                    target="_blank"
                    :href="item.link"
                    class="main-nav-link"
                  >
                    {{ item.text }}
                  </a>
                  <router-link
                    v-else
                    tabindex="0"
                    :to="item.link"
                    class="btn btn-primary d-none d-lg-block m-0 ml-half text-white fw-bold main-nav-link-btn"
                  >
                    {{ item.text }}
                  </router-link>
                </div>
              </li>
            </ul>
          </nav>
        </b-col>
        <b-col cols="auto" class="d-flex ml-auto align-items-center">
          <!-- Logo -->
          <a :href="`https://workconsult.at/${lang}`" class="d-block ml-2">
            <div class="py-1 py-sm-3 h-100">
              <img :src="require('@/assets/img/logo/logo-wconat.png?v=2')" alt="workconsult" class="img img-fluid logo-header" />
            </div>
          </a>
          <!-- /Logo -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

interface LinkItem {
  text: string
  link?: string
  hasIcon?: boolean
  isLocalLink?: boolean
}

@Component({
  components: {
    LanguageHeader,
  },
})
export default class HeaderInformationNavigationTew extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  get links(): LinkItem[] {
    return [
      {
        text: this.translations[13801] || 'Willkommen',
        link: `https://workconsult.at/${this.lang}/welcome`,
      },
      {
        text: this.translations[14996] || 'Bildungsnetzwerk',
        link: `https://workconsult.at/${this.lang}/educational-network`,
      },
      {
        text: this.translations[2053] || 'Qualifizierung',
        link: `https://workconsult.at/${this.lang}/german-language`,
      },
      {
        text: this.translations[6229] || 'Vermittlung',
        link: `https://workconsult.at/${this.lang}/job-placement`,
      },
      {
        text: this.translations[14997] || 'Talentpool',
        link: '/',
        isLocalLink: true,
      },
      {
        text: this.translations[14998] || 'Über uns',
        link: `https://workconsult.at/${this.lang}/about-us`,
      },
      {
        text: this.translations[5661] || 'Kontakt',
        link: `https://workconsult.at/${this.lang}/contact`,
      },
    ];
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    max-width: 150px;
    @media (min-width: 786px) {
      max-width: 200px;
    }
    @media (min-width: 1400px) {
      max-width: 230px;
    }
  }
  .main-nav-item {
    margin: 0 3px 0 0;
  }
  .main-nav-link {
    color: #68726A;
    font-weight: 500;
    background-color: #EEF1F0;
    padding: 5px 15px;
    margin: 5px 0;
    border-radius: 5px;
    transition: none;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
    &:hover, &:active {
      background-color: var(--aba-primary);
      color: #ffffff!important;
    }
  }
  .main-nav-link-btn {
    font-weight: 500;
    padding: 5px 15px;
    margin: 5px 0;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.main-nav-list {
  background: #ffffff;
  padding: 0;
  margin: 0;
}
.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--aba-secondary-600));
    text-decoration: none;
  }
}

//sub-nav
ul.main-nav-list li:hover div > ul {
  visibility: visible;
  opacity: 1;
}
ul.main-nav-list ul {
  list-style: none;
  margin: 5px 0 0;
  padding: 10px 0 0;
  visibility: hidden;
  position: absolute;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear, visibility 0.2s linear;
  -moz-transition: opacity 0.2s linear, visibility 0.2s linear;
  -o-transition: opacity 0.2s linear, visibility 0.2s linear;
  transition: opacity 0.2s linear, visibility 0.2s linear;
  top: 100%;
  left: 0px;
  text-transform: none;
  font-weight: 600;
  line-height: 1.4em;
  -moz-box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 250px;
  overflow: hidden;
  background: var(--aba-primary);
}

ul.main-nav-list ul li {
  clear: both;
  width: 100%;
  background: none transparent;
}
ul.main-nav-list ul li {
  display: inline;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
  background-image: none;
  border-radius: 5px;
  margin-right: 2px;
}
ul.main-nav-list ul li a {
  padding: 3px 10px 3px 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: block;
  border: 0 none;
  clear: both;
  border-radius: 0px;
  background-color: transparent;
}
ul.main-nav-list ul li a:hover,
ul.main-nav-list ul li.active a {
  color: white;
}
ul.main-nav-list ul li:last-child a {
  padding: 3px 10px 12px 12px;
}
</style>
